import { type Socket, io } from "socket.io-client";

/**
 * Singleton socket.io client for live updates.
 *
 * Connects to the Hono server's `/api/socket.io` endpoint (same origin —
 * Vite proxies it in dev, Caddy in prod) over WebSocket with an
 * automatic long-polling fallback. socket.io reconnects on its own with
 * backoff, so callers never write retry logic — they just listen for
 * `change` (a DB change happened, re-fetch) and `timer` (this user's
 * running Clockify timer changed). The Auth.js cookie rides the
 * handshake, so the server authenticates it like any other request.
 */
let socket: Socket | null = null;

export function getSocket(): Socket {
  if (!socket) {
    socket = io({
      path: "/api/socket.io",
      withCredentials: true,
    });
  }
  return socket;
}
